export const PermmisionPostsTypeEnum = {
    RunnerOnly: 2,
    RunnerAndCode: 4
}

export const PermmisionPostsTypeEnumText = {
    RunnerOnly: "RunnerOnly",
    RunnerAndCode: "RunnerAndCode"
}